import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function SuperuserRoute({ children }) {
  const { user } = useAuth();

  return user?.is_superuser ? children : <Navigate to="/pecas" replace />;
}

export default SuperuserRoute;
